<template>
  <label
    class="form-input-label mb-2"
  >{{ label }}<span
    v-if="required"
    class="text-red-600"
  >&nbsp;*</span></label>
</template>

<script>
export default {
  props: {
    required: {
      default: false,
      type: Boolean
    },
    label: {
      required: true,
      type: String
    }
  }
};
</script>
